module.exports = __webpack_public_path__ + "img/材料力学5_12_2.8fda43fa.jpg";